import React from "react";
import "./card-rates-home-mobile.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardRatesDescriptionHome from "../../atoms/card-rates-description-home/card-rates-description-home";
interface ShareCardInterface {
  datas: any;
}
const CardPayHomeMobile = (props: ShareCardInterface) => {
  const { datas } = props;
  const component = (dots) => {
    return (
      <div style={{ bottom: "-10px" }}>
        <ul>{dots}</ul>
      </div>
    );
  };
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    rows: 3,
    appendDots: (dots) => component(dots),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1.22,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.22,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          appendDots: (dots) => component(dots),
        },
      },
    ],
  };

  return (
    <div className="m-share-modal-home-mobile">
      <div className="m-share-modal-home-mobile-internal">
        <Slider {...settings}>
          {datas[0].referenciaPlantillaContenido.map((value, key) => {
            return (
              <div key={"rate" + key}>
                {value.imagenPrincipal ? (
                  <>
                    <CardRatesDescriptionHome datas={value} />
                  </>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
export default CardPayHomeMobile;
